import React, { useEffect, useState } from "react";
import OrderList from "../components/orderList";
import axios from 'axios';
import { io } from 'socket.io-client';
import MinimalLayout from "../components/minimalLayout";
import config from "../config";

const Kitchen = () => {
    const apiBaseUrl = config.REACT_APP_API_BASE_URL;
    const [tableOrders, setTableOrders] = useState({ orders: [] });
    const fetchTableOrders = async () => {
        try {
            const { data: ordersData } = await axios.get(`${apiBaseUrl}/api/orders/get-kitchen-order`);

            setTableOrders(ordersData);

        } catch (error) {
            console.error("❌ Error fetching orders", error);
        }
    };

    useEffect(() => {
        // const socket = io('http://localhost:8080');
        let socketUrl;

        try {
            socketUrl = apiBaseUrl;
        } catch {
            socketUrl = apiBaseUrl;
        }

        const socket = io(socketUrl);

        socket.on('connect', () => {
            console.log('🟢 Connected to socket.io server');
        });

        socket.on('testEvent', (data) => {
            console.log('✅ Received test event:', data);
        });

        socket.on('disconnect', () => {
            console.log('🔴 Disconnected from socket.io server');
        });

        return () => socket.disconnect();
    }, []);

    useEffect(() => {
        fetchTableOrders();
    }, []);

    useEffect(() => {
        // const socket = io('http://localhost:8080');
        let socketUrl;
        try {
            socketUrl = apiBaseUrl;
        } catch {
            socketUrl = apiBaseUrl;
        }

        const socket = io(socketUrl);

        socket.on('newKitchenOrder', (order) => {
            setTableOrders(prev => [order, ...prev]);
        });

        return () => socket.disconnect();
    }, []);


    return <MinimalLayout>
        <OrderList orders={tableOrders} setOrders={setTableOrders} />

    </MinimalLayout>
}

export default Kitchen;